import * as contexts from "./contexts";

export const SURVEYS = [contexts.SURVEYS];
export const SPP = [contexts.SPP];
export const SYSTEM = ["system"];